import "./FormDeclaration.scss";
import { useEffect, useState, useContext, useRef } from "react";
import {
  Col,
  Row,
  Button,
  notification,
  Modal,
  Spin
} from "antd";
import { Section } from './components'
import moment from "moment";
import HelloSign from 'hellosign-embedded';

import { useTranslation } from "react-i18next";
import { globalContext } from "../../../contexts";
import apiConfig from '../../../config/api'
import { signCDIFormPromise, sendFormPromise } from "../../InterestConflicts/promises";
import Logo from "../../../layouts/commonComponent/components/Logo/Logo";

const FormDeclaration = ({ client, apiForm, form, mode, lang, hasSign}) => {

  const { t } = useTranslation('forms')
  const [isLoading, setiIsLoading] = useState(true)
  const { loadFormDatasource } = useContext(globalContext)
  const [decl, setDecl] = useState(form)
  const [ showErrors, setShowErrors ] = useState(false)
  const [openSigner, setOpenSigner] = useState(false);
  const [signData, setSignData] = useState(null);
  const [apiFormObj, setApiFormObj] = useState(apiForm);
  const [signed, setSigned] = useState(false);
  const [sending, setSending] = useState(false);
  const [keySendDocument, setKeySendDocument] = useState(Math.random())
  const apiFormRef = useRef(apiForm);

  const setApiForm = data => {
    apiFormRef.current = data;
    setApiFormObj(data);
  };

  useEffect(() => {
    if(showErrors) {
      const send = async() => {
        let hasErrorsForm = false
        let errores = []
        decl.sections.map(section => {
          const { hasErrors, descriptions } = validaSection(section)
          if(hasErrors) {
            hasErrorsForm = true
            errores.push(descriptions)
            /*
            notification.error({
              className: 'notif-error-required-fields',
              message: t('forms.errors.missingRequiredFields'),
              description: descriptions
            })
              */
          }
        })
        if(hasErrorsForm) {
          notification.error({
            className: 'notif-error-required-fields',
            message: t('forms.errors.formHasErrors'),
            description: errores[0]
          })
        }else {
          setOpenSigner(true)
          const formData = new FormData()
          formData.append('formId', apiForm.id);
          if(hasSign) {
              await signAndSend(apiForm)
          }else {
              await sendDocument()
          }
          setOpenSigner(false)
        }
      }
      send()
    }
  }, [keySendDocument, showErrors])

  useEffect(() => {
    loadFormDatasource(form.formParentId ? form.formParentId : form.id).then(r => {
      setiIsLoading(false)
    })

    const handleMessage = (message) => {
      if(message.data && typeof message.data === 'string' && message.data.startsWith('DOCUSIGN') && apiConfig.url.startsWith(message.origin)) {
          const data = message.data.split('|')
          if(data.length === 4) {
            if(data[1] === "signing_complete") {
                const reqId = data[2] + "|" + data[3]
                sendDocument(reqId, apiFormRef.current)
            }else {
                closeHandlerSigner();
                notification["warning"]({
                    message: t('forms.messages.signatureCancelled')
                });
            }
          }
      }
    }

    window.addEventListener("message", handleMessage);
    return function () {
        window.removeEventListener("message", handleMessage);
    };
	}, [])

  const refreshForm = (f) => {
    setDecl(f)
  }

  const closeHandlerSigner = () => {
      setSignData(null)
      setOpenSigner(false)
  }

  const validaSection = (section) => {
    let hasErrors = false
    let descriptions = []
    section.components && section.components.map(component => {
      if(component.type === 'FIELDSET') {
        let errores = component.fields.filter(f => f.visible && ((f.required && (f.value === null || f.value === undefined || f.value === '')) || f.errors) );
        if(errores.length > 0) {
          let title = component.title ? component.title : section.title
          descriptions.push(<p>{t('forms.errors.missingDataSection', { section: title && title[lang] })}</p>)
          hasErrors = true
        }
      }else if(component.type === 'DECL') {
        if(component.decision === null || component.decision === undefined) {
          hasErrors = true
          descriptions.push(<p>{t('forms.errors.mustSelectDecisionSection', { section: section.title && section.title[lang] })}</p>)
        }else if(component.decision) {
          const minRows = parseInt(component.fieldSet?.minRows ?? 1, 10)
          if(component.records.length < minRows) {
            hasErrors = true
            descriptions.push(<p>{t('forms.errors.mustAddRecordsSection', { minRows, plural: minRows>1?'s':'', section: section.title && section.title[lang] })}</p>)
          }
        }
      }else if(component.type === 'TABLE') {
        const minRows = parseInt(component.fieldSet?.minRows ?? 0, 10)
        if(component.records.length < minRows) {
          hasErrors = true
          descriptions.push(<p>{t('forms.errors.mustAddRecordsSection', { minRows, plural: minRows>1?'s':'', section: section.title && section.title[lang] })}</p>)
        }
      }else if(component.type === 'PARAGRAPH') {
        let errores = component.fieldSet && component.fieldSet.fields && component.fieldSet.fields.filter(f => f.show && f.required && (f.value === null || f.value === undefined || f.value === ''));
        if(errores && errores.length > 0) {
          let title = component.title ? component.title : section.title
          hasErrors = true
          descriptions.push(<p>{t('forms.errors.missingDataSection', { section: title && title[lang] })}</p>)
        }else {
          errores = component.fieldSet && component.fieldSet.fields && component.fieldSet.fields.filter(f => f.show && f.validation && f.value && f.error === true);
          if(errores && errores.length > 0) {
            let title = component.title ? component.title : section.title
            hasErrors = true
            descriptions.push(<p>{t('forms.errors.errorsSection', { section: title && title[lang] })}</p>)
          }
        }
      }else if(component.type === 'FIELD') {
        if(component.required && (component.value === null || component.value === undefined || component.value === '')) {
          hasErrors = true
          descriptions.push(<p>{t('forms.errors.missingDataSection', { section: section.title && section.title[lang] })}</p>)
        }
      }else if(component.type === 'DECISION') {
        if(component.decision === null || component.decision === undefined) {
          hasErrors = true
          descriptions.push(<p>{t('forms.errors.mustSelectDecisionSection', { section: section.title && section.title[lang] })}</p>)
        }else {
          let subSection = component.decision ? component.compSi : component.compNo
          const validation = validaSection(subSection)
          if(validation?.hasErrors) {
            hasErrors = true
            if(validation?.descriptions) {
              descriptions.push(validation?.descriptions)
            }
          }
        }
      }else if(component.type === 'TEXT' && component.required) {
        let title = component.hasTitle && component.title ? component.title : section.title
        if(component.value === null || component.value === undefined || component.value === '') {
          descriptions.push(<p>{t('forms.errors.missingDataSection', { section: title && title[lang] })}</p>)
          hasErrors = true
        }else if(component.maxLength && component.value && component.value.length > component.maxLength) {
          descriptions.push(<p>{t('forms.errors.maxLengthOverflowSection', { section: title && title[lang] })}</p>)
          hasErrors = true
        }
      }
    })
    return {hasErrors, descriptions}
  }

  const sendFormDocument = async () => {
    setShowErrors(true)
    setKeySendDocument(Math.random())
  }
  
  const signAndSend = async (formObj) => {
    let record = formObj.recipient.record
    let _emails = ["no@email.com"];
    if(record.email != null) {
        _emails = record.email.split(",");
    }
    var _email = _emails[0].trim();
    let signParams = await signCDIFormPromise(formObj.id, _email)
    setSignData(signParams)
    if(signParams.embedUrl == "signed") {
      notification["warning"]({
        message: t('forms.messages.alreadySigned')
      })
      setSigned(true)
      sendDocument(signParams.requestId)
    }else {
      if(signParams.embedUrl) {
        if(signParams.provider == "HELLOSIGN") {
          if(signParams.clientId != "") {
            const client = new HelloSign({
                clientId: signParams.clientId
            });
            let testMode = !apiConfig.url.startsWith('https://api.amlupdate')
            client.open(signParams.embedUrl, {
                testMode
            });
            client.on('sign', () => {
                setSigned(true)
                sendDocument(signParams.requestId)
            });
          }else {
            notification["error"]({
                message: t('forms.errors.signatureServiceTitle'),
                description: signParams.message
            })
          }
        }
      } else {
        notification["error"]({
            message: t('forms.errors.signatureService'),
            description: signParams.message
        })
      }
    }
  }

  const sendDocument = (requestId = "", formObj = apiForm) => {
    if(requestId === "") {
      Modal.confirm({
          title: t("messages.aml.wantSubmitForm", {ns: 'translations' }),
          content: t("messages.aml.pressSend", {ns: 'translations' }),
          okText: t("messages.aml.send", {ns: 'translations' }),
          cancelText: t("messages.aml.cancel", {ns: 'translations' }),
          onOk() {
            sendForm(requestId, formObj);
          },
          onCancel() {},
      });
    }else {
      sendForm(requestId, formObj);
    }
  }

  const sendForm = (requestId, formObj) => {
    setSending(true)
    sendFormPromise(formObj.id, requestId)
      .then((response) => {
        if (response.code === "OK") {
          let formSend = { ...formObj, status: "SENT" };
          setApiForm(formSend);
          closeHandlerSigner()
        } else {
          notification["error"]({
            message: t("messages.aml.notifications.anErrorOcurred", {ns: 'translations' }),
            description: t('forms.errors.contactSupport')
          });
          setApiForm(response.form);
        }
      })
      .finally(() => {
        setSending(false)
      })
  }

  const getLogoPosition = (logos, position) => {
    let pos = null
    logos && logos.map((logo) => {
        if(logo.position === position) pos = position
    })
    return pos
  }

  return (
    isLoading ? <Spin />
    :
    <div className={"form-manager-declaration " + mode}>
      <div className={"form-form " + mode}>
        <div className="form-header">
          { form.logo?.hasLogo && form.logo?.position && form.logo?.origin && client &&
            <Row className="row-logo">
              <Col span={8} offset={form.logo?.position === "CENTER" ? 8 : form.logo?.position === "RIGHT" ? 16 : 0} className={form.logo?.position}>
                { form.logo?.origin === "CLIENT" ?
                  <Logo currentUser={{clientId: client.id}} />
                  : form.logo?.origin === "COMPANY" && apiForm ?
                  <Logo currentUser={{userId: apiForm.recipient.request.createUser?.id, subclienteId: apiForm.recipient.record?.subcliente?.id }} />
                  : form.logo?.origin === "CUSTOM" && form.logo?.base64 &&
                  <div className="logo">
                    <img src={form.logo.base64}></img>
                  </div>
                }
              </Col>
            </Row>
          }
          <Row>
            <h2 className="form-title">{form.name}</h2>
            <h2 className="form-title">{form.title?.[lang]}</h2>
          </Row>
          <Row>
            <Col span={12}>{t('forms.label.fecha')}:&nbsp;&nbsp;<span className="inputHeader">{moment(form.creationDate).format('DD-MM-YYYY')}</span></Col>
            <Col span={12} style={{textAlign:'right', paddingRight:'20px'}}>{t('forms.label.folio')}:&nbsp;&nbsp;<span className="inputHeader">{form.folio?form.folio:<>&nbsp;&nbsp;&nbsp;&nbsp;</>}</span></Col>
          </Row>
        </div>
        <div className="form-content">
          {apiFormObj?.status === "SENT" && mode === "html" ? (
            <>
              <h3 style={{ textAlign: "center", margin: 0, padding: 10 }}>{t('forms.messages.formWasSent1', {name: apiForm.recipient.record.name})}<br />{t('forms.messages.formWasSent2')}<br/><br/>{apiForm.recipient.record.email}</h3>
            </>
            ) 
            :
            (apiFormObj?.status !== 'SENT' || mode === 'pdf') && decl.sections && decl.sections.map(section =>
              <Section client={client} decl={decl} record={apiForm?.recipient?.record} section={section} mode={sending || openSigner ? "pdf" : mode} refreshForm={refreshForm} showErrors={showErrors} lang={lang} />
            )
          }
        </div>
        { mode !== 'pdf' && apiForm && apiFormObj?.status !== 'SENT'  &&
          <Row className="form-actions">
              <Col offset={20} span={4}>
                <Button onClick={sendFormDocument} disabled={mode !== 'html' || sending || openSigner} type="primary" style={{padding:'0px 27px'}} icon={sending || openSigner ? 'loading' : 'file-protect'}>
                  { hasSign ? t('forms.buttons.sign') : t('forms.buttons.send') }
                </Button>
              </Col>
          </Row>
        }
        { mode === 'pdf' && apiForm && apiFormObj?.status !== 'SENT' && hasSign && !signed &&
          <Row className="button-row">
              <Col className="submitTrabajador" offset={18} style={{
                fontSize: 4,
                padding: '70px 0px 40px',
                color: 'rgba(255,255,255,0)'
                }}
              >
                Firma_aqui
              </Col>
          </Row>
        }
        { hasSign && signData?.embedUrl && signData?.provider === "DOCUSIGN" &&
            <Modal  
                visible={true} title={t('forms.label.signature')} width={1200}
                onCancel={closeHandlerSigner}
                footer={[<Button onClick={closeHandlerSigner}>{t('messages.aml.btnClose')}</Button>]}
            >
                <iframe
                    title="DocuSign" 
                    id="iframeDocument" 
                    src={signData.embedUrl} 
                    width="100%"
                    height="480">
                </iframe>
            </Modal>
        }
      </div>
    </div>
  )
}

export default FormDeclaration;
